import Vue from 'vue'
import App from './App.vue'

import Antd, { version } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less';
import '@/assets/less/JAreaLinkage.less'
import VueAreaLinkage from 'vue-area-linkage'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(VueAreaLinkage);

new Vue({
	render: h => h(App),
}).$mount('#app')
